import { EditSpeakOptions } from "../EditSpeakOptions";
import { Say } from "../widgets/Say";
import { Say2 } from "../widgets/Say2";
import { ConvertMandarin } from "./ConvertMandarin";
import { PinyinLetters } from "./PinyinLetters";
import { pinyinLetters, pinyinTones } from "./PinyinSamples";

/** a page where you can listen to a synth version of Standard Chinese (Mandarin) */
export function MandarinArea() {
  return (<>
    <h1>Standard Chinese</h1>

    <div style={{ display: 'grid', gridTemplateColumns: '600px 20px 220px', justifyContent: 'center' }}>
      <div>
        <ConvertMandarin />
        <br /><br />
        <ExplainLetters />
        <PinyinLetters title='Pinyin letters' symbols={pinyinLetters} />
        <ExplainTones />
        <PinyinLetters title='Tones' symbols={pinyinTones} />
      </div>

      <div></div>

      <div style={{ textAlign: 'left' }}>
        Synthesizer Settings<br /><br />
        <EditSpeakOptions vertical={true} />
      </div>
    </div>
  </>);
}

function ExplainLetters() {
  return (<div style={{ textAlign: 'left' }}>
    <p>
      The symbols in Pinyin were chosen to be close to the sounds typically associated with the letters.
      But many sounds don't exactly align with the sounds in English.
      The below chart uses <i>like</i> for sounds that are very similar to an English sound,
      <i>close to</i> for sounds that are a bit further away, and <i>varies</i> for cases
      where the actual sound depends on the surrounding letters.
    </p>
    <p>
      One way that Mandarin differs from English is that Mandarin considers many <i>aspirated</i> sounds
      to be distinct from <i>unaspirated</i> sounds, while English speakers typically don't notice the difference.
      An aspirated sound ends with a slight puff of air, such as the <i>p</i> in the English word <Say say="[ˈpʰɑt]">pot</Say>.
      In contrast, English speakers don't aspirate a <i>p</i> that follows an <i>s</i>, such as in <Say say="[ˈspɑt]">spot</Say>.
      Mandarin considers those different sounds, with the aspirated version represented with <b>p</b> and
      the unaspirated version with <b>b</b>.
      An English speaker may think an unaspirated <Say2>p</Say2> sounds like a <Say2>b</Say2>.
      Something similar applies to unaspirated <Say2>t</Say2> versus <Say2>d</Say2> and unaspirated <Say2>k</Say2> versus <Say2>g</Say2>.
    </p>
  </div>);
}

function ExplainTones() {
  return (<div style={{ textAlign: 'left' }}>
  </div>);
}
